var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},_vm._l((_vm.arr),function(item){return _c('div',{key:item,staticStyle:{"width":"100%","height":"100%"}},[_c('test1')],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }